import { Command } from 'commander';
import { SwitchProfileCommand } from './switchProfileCommand';
import { InitProfileCommand } from './initProfileCommand';
import { ShowProfileEntityInfoCommand } from './showProfileEntityInfoCommand';
import { IncludeCommand } from './includeCommand';
import { OverrideCommand } from './overrideCommand';
import { NotifficationCommand } from './notiffications/notifficationCommand';

export function ProfileCommand(): Command {
  const profileCommand = new Command('profile')
    .alias('p')
    .description(
      'Provides a list of commands that are helpful for building profile',
    );

  profileCommand.addCommand(SwitchProfileCommand());
  profileCommand.addCommand(InitProfileCommand());
  profileCommand.addCommand(IncludeCommand());
  profileCommand.addCommand(OverrideCommand());
  profileCommand.addCommand(ShowProfileEntityInfoCommand());
  profileCommand.addCommand(NotifficationCommand());
  return profileCommand;
}
